<app-menu-common url="sales"></app-menu-common>

<div class="invoicing-page">

  <!-- Entête : ligne 1 = titre et toutes les actions, ligne 2 = les filtres de F4 (documentation.html#front.sales.invoice-creation-v2) -->
  <div class="toolbar-card">

    <div class="header-row">
      <div class="toolbar-title">
        <mat-icon class="toolbar-icon">post_add</mat-icon>
        <span>Facturation des BL</span>
        <span class="version-tag">V2</span>
      </div>

      <span class="spacer"></span>

      <span class="badge-count big" matTooltip="Tous les bons de livraison non facturés, filtres ignorés">{{ rows.length }} BL à facturer</span>

      <a mat-stroked-button class="hdr-btn" routerLink="/sales/invoices" matTooltip="Consulter les factures clients">
        <mat-icon>receipt_long</mat-icon>Factures clients
      </a>
      <a mat-stroked-button class="hdr-btn" routerLink="/sales/bank-lettering" matTooltip="Ouvrir le lettrage bancaire">
        <mat-icon>account_balance</mat-icon>Rapprochement bancaire
      </a>
      <button mat-stroked-button class="hdr-btn" (click)="loadData()" [disabled]="loading" matTooltip="Relire les bons de livraison à facturer">
        <mat-icon [class.spinning]="loading">refresh</mat-icon>Actualiser
      </button>
      <button mat-stroked-button class="hdr-btn" (click)="selectAll()" [disabled]="visible.length === 0" matTooltip="Sélectionner tous les BL affichés">
        <mat-icon>select_all</mat-icon>Tout sélectionner
      </button>
      <button mat-stroked-button class="hdr-btn" (click)="deselectAll()" [disabled]="selectedIds.size === 0">
        <mat-icon>deselect</mat-icon>Tout désélectionner
      </button>

      <app-action-bar class="hdr-action-bar" [hassave]="false" [canSave]="false" saveTooltip="Rien à enregistrer sur cet écran : la facturation part du bouton Facturer">
        <app-invoice-creation-action (submitEmitter)="onActionBarAction($event)"></app-invoice-creation-action>
      </app-action-bar>
    </div>

    <div class="filters-row">
      <div class="filter-item">
        <label class="filter-label" title="Ne montrer que les BL d'une commande : Tab ou Entrée filtre, l'icône ouvre la commande dans un nouvel onglet">Id commande</label>
        <smart-input #orderIdNav width="100px" type="number" placeholder="N°" icon="link"
          iconClass="custom-icon-button primary" [iconHref]="orderIdHref" iconTarget="_blank"
          [(ngModel)]="orderIdText" (valueChange)="onOrderIdChange($event)"
          (blurred)="onOrderIdBlur($event)" (enterPressed)="onOrderIdValidate($event)" />
      </div>

      <div class="filter-item partner-filter">
        <label class="filter-label">Client</label>
        <app-search-partner [currentPartner]="customer" width="280px" [showSelectionInInput]="true"
          (partnerChange)="customerChange($event)"></app-search-partner>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-state" title="Statut de la commande du BL">Statut</label>
        <select id="flt-state" class="custom-select state-select" [(ngModel)]="filter.state" (change)="onSelectChange()">
          <option value="-1">Tous les statuts</option>
          @for (su of SalesOrderState | keyvalue; track su) {
            <option [value]="su.key">{{ getLabel(su.key) }}</option>
          }
        </select>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-doctype">Type</label>
        <select id="flt-doctype" class="custom-select type-select" [(ngModel)]="filter.doc_type" (change)="onSelectChange()">
          <option value="-1">Tous les types</option>
          @for (t of docTypes; track t) {
            <option [value]="t">{{ docTypeName(t) }}</option>
          }
        </select>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-store" title="Établissement du poste où la commande a été saisie">Magasin&nbsp;/&nbsp;Ets.</label>
        <select id="flt-store" class="custom-select store-select" [(ngModel)]="filter.store" (change)="onSelectChange()">
          @for (store of stores; track store) {
            <option [value]="store.id">{{ store.name }}&nbsp;{{ (store.id ?? 0) > 0 ? store.id : '' }}</option>
          }
        </select>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-user" title="Employé qui a saisi la commande">Employés</label>
        <select id="flt-user" class="custom-select user-select" [(ngModel)]="filter.user" (change)="onSelectChange()">
          @for (user of users; track user) {
            <option [value]="user.id">{{ ((user.firstname ?? '') + ' ' + (user.lastname ?? '')).trim() }}</option>
          }
        </select>
      </div>

      <div class="filter-item date-filter" title="Date de création de la commande du BL, comme dans la liste des commandes (pas la date de livraison)">
        <label class="filter-label">Commande du</label>
        <app-select-date [date]="filter.datstart" (dateChange)="dateChange($event, 'datstart')"></app-select-date>
      </div>

      <div class="filter-item date-filter" title="Date de création de la commande du BL, comme dans la liste des commandes (pas la date de livraison)">
        <label class="filter-label">au</label>
        <app-select-date [date]="filter.datend" (dateChange)="dateChange($event, 'datend')"></app-select-date>
      </div>

      <div class="period-presets" role="group" aria-label="Raccourcis de période">
        @for (p of periods; track p.key) {
          <button type="button" class="period-btn" [class.active]="isPeriod(p.key)" [title]="p.title" (click)="setPeriod(p.key)">{{ p.label }}</button>
        }
      </div>

      <div class="toolbar-actions">
        <button mat-flat-button class="error btn-inline" aria-label="Effacer" title="Effacer les filtres : tous les BL à facturer" (click)="onCancel()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Contenu : liste des BL 70 % / articles du BL survolé 30 % -->
  <div class="content-row">

    <div class="table-card">
      <div class="table-header-bar">
        <div class="table-title">
          <mat-icon>local_shipping</mat-icon>
          <span>Bons de livraison à facturer</span>
          <span class="badge-count">{{ visible.length }}</span>
          @if (hiddenCount > 0) {
            <button type="button" class="hidden-chip" (click)="onCancel()" matTooltip="BL à facturer que les filtres cachent : cliquer pour tout afficher">
              + {{ hiddenCount }} hors filtres
            </button>
          }
          @if (loadedAt) {
            <span class="loaded-at" matTooltip="Le serveur renvoie toujours tous les BL non facturés ; les filtres trient cette lecture sans le rappeler. « Actualiser » relit la liste.">lue à {{ loadedAt | date:'HH:mm' }}</span>
          }
        </div>

        <div class="kpi-inline">
          <div class="kpi-chip" matTooltip="Total TTC des BL affichés">
            <mat-icon class="kpi-icon">functions</mat-icon>
            <span class="kpi-label">Total affiché</span>
            <span class="kpi-value">{{ totalVisible | number:'1.2-2' }}&nbsp;€</span>
          </div>
          <div class="kpi-chip selection" [class.zero]="selectedIds.size === 0" matTooltip="BL cochés : ce que « Facturer » émettra">
            <mat-icon class="kpi-icon">check_box</mat-icon>
            <span class="kpi-label">Sélection</span>
            <span class="kpi-value">{{ selectedIds.size }}&nbsp;BL · {{ totalSelected | number:'1.2-2' }}&nbsp;€</span>
          </div>
        </div>
      </div>

      <div class="table-bl">
        <div class="bl-line entete">
          @for (col of displayedColumnsInfo; track col[0]) {
            @if (col[0] === 'sel') {
              <div class="cell sel-cell">
                <mat-checkbox color="primary" [checked]="allVisibleSelected" [indeterminate]="selectedIds.size > 0 && !allVisibleSelected"
                  [disabled]="visible.length === 0" (change)="toggleAllVisible($event.checked)" matTooltip="Tout cocher / tout décocher"></mat-checkbox>
              </div>
            } @else if (col[0] === 'cancel') {
              <div class="cell cancel-cell"></div>
            } @else {
              <div [class]="'cell ' + col[0] + '-cell ' + col[2]" (click)="sortBy(col[0])">
                <span class="sort-arrow">{{ col[3] === undefined ? '' : (col[3] ? '&#8593;' : '&#8595;') }}</span> {{ col[1] }}
              </div>
            }
          }
        </div>

        @if (visible.length > 0) {
          <!-- Dès 2 BL d'un même client : un groupe encadré, entête au nom du client, qu'aucun tri ne sépare -->
          @for (b of blocks; track b.key) {
            @if (b.rows.length > 1) {
              <div class="bl-group">
                <div class="bl-group-head">
                  <div class="cell group-name-cell" [title]="b.customerName">
                    <mat-icon class="group-icon">workspaces</mat-icon>
                    <span class="group-name">{{ b.customerName }}</span>
                    <span class="group-count">{{ b.rows.length }} BL</span>
                  </div>
                  <div class="cell total-cell group-total" matTooltip="Total TTC des BL du groupe">{{ b.total_taxi | number:'1.2-2' }}</div>
                  <div class="cell cancel-cell"></div>
                </div>
                @for (r of b.rows; track r.id) {
                  <ng-container *ngTemplateOutlet="blRow; context: { $implicit: r }"></ng-container>
                }
              </div>
            } @else {
              <ng-container *ngTemplateOutlet="blRow; context: { $implicit: b.rows[0] }"></ng-container>
            }
          }
        } @else if (loading) {
          <div class="list-state">
            <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4" color="primary"></mat-progress-spinner>
            <span>Chargement des bons de livraison à facturer…</span>
          </div>
        } @else {
          <div class="list-state">
            <mat-icon class="empty-icon">{{ rows.length ? 'filter_alt_off' : 'task_alt' }}</mat-icon>
            @if (loadFailed) {
              <div class="empty-title">Lecture des bons de livraison en échec</div>
              <button mat-stroked-button color="primary" class="action-btn" (click)="loadData()"><mat-icon>refresh</mat-icon>Réessayer</button>
            } @else if (rows.length) {
              <div class="empty-title">Aucun BL dans ces filtres</div>
              <div class="empty-subtitle">{{ rows.length }} BL à facturer en dehors&nbsp;: élargissez la période, le magasin ou l'employé.</div>
              <button mat-stroked-button color="primary" class="action-btn" (mousedown)="$event.preventDefault()" (click)="onCancel()"><mat-icon>clear</mat-icon>Afficher tous les BL</button>
            } @else {
              <div class="empty-title">Aucun bon de livraison en attente</div>
              <div class="empty-subtitle">Toutes les livraisons éligibles ont été facturées.</div>
            }
          </div>
        }
      </div>
    </div>

    <ng-template #blRow let-r>
      <!-- Une ligne de BL, seule ou dans son groupe -->
      <div class="bl-line" [ngClass]="r.color"
        [class.row-hovered]="r.id === hovered?.id" [class.row-checked]="selectedIds.has(r.id)"
        [class.no-bill]="r.billAddr === null" [class.is-canceled]="r.state === SalesOrderState.CANCELED"
        (mouseenter)="onHover(r)" (mousedown)="keepOrderIdFocus($event)" (click)="toggle(r)">
        <div class="cell sel-cell" (click)="$event.stopPropagation()">
          <mat-checkbox color="primary" [checked]="selectedIds.has(r.id)" (change)="toggle(r, $event.checked)"></mat-checkbox>
        </div>
        <div class="cell id-cell">{{ r.id }}</div>
        <div class="cell order-cell">
          <a class="order-link" [routerLink]="['/sales/quotation', r.orderId]" (click)="$event.stopPropagation()" matTooltip="Ouvrir la commande">{{ r.orderId }}</a>
        </div>
        <div class="cell created-cell">{{ r.created | date:'dd/MM/yy HH:mm' }}</div>
        <div class="cell delivery-cell" [matTooltip]="r.modeLabel">
          {{ r.askdatdel | date:'dd/MM/yy' }}<span class="mode-tag">{{ r.modeLabel }}</span>
        </div>
        <div class="cell type-cell">
          @if (r.docType) { <span class="type-chip" [class.chip-avoir]="r.docType === 'AVOIR'">{{ docTypeLabel(r) }}</span> }
        </div>
        <div class="cell store-cell">{{ storeOf(r) }}</div>
        <div class="cell station-cell">{{ r.stationId }}</div>
        <div class="cell user-cell">{{ userShortName(r.userId) }}</div>
        <div class="cell status-cell"><span class="state-pill">{{ getLabel(r.state) }}</span></div>
        <div class="cell customer-cell" [title]="r.customerName">{{ r.customerName }}</div>
        <div class="cell bill-cell" [title]="r.billAddr ?? ''">
          @if (r.billAddr !== null) { {{ r.billAddr }} } @else {
            <span class="missing-bill"><mat-icon>warning</mat-icon>Adresse de facturation non spécifiée</span>
          }
        </div>
        <div class="cell lines-cell">{{ r.lines.length }}</div>
        <div class="cell total-cell">{{ r.total_taxi | number:'1.2-2' }}</div>
        <div class="cell cancel-cell" (click)="$event.stopPropagation()">
          <span [matTooltip]="r.signed ? 'BL signé : il ne s\'annule plus' : 'Annuler le BL : il est supprimé, ses quantités redeviennent à livrer sur la commande'">
            <button type="button" class="cancel-btn" [disabled]="r.signed || cancelingId !== null" (click)="cancelBl(r)" aria-label="Annuler le BL">
              <mat-icon [class.spinning]="cancelingId === r.id">{{ cancelingId === r.id ? 'autorenew' : 'block' }}</mat-icon>
            </button>
          </span>
        </div>
      </div>
    </ng-template>

    <!-- Articles du BL survolé : tout est déjà dans la réponse de la liste, aucune requête au survol -->
    <div class="rightcontainer">
      @if (hovered; as h) {
        <div class="detail-card">
          <div class="detail-head">
            <span class="detail-title">BL N°{{ h.id }}</span>
            <a class="detail-link" [routerLink]="['/sales/quotation', h.orderId]">Commande N°{{ h.orderId }}</a>
            @if (h.docType) { <span class="type-chip" [class.chip-avoir]="h.docType === 'AVOIR'">{{ docTypeLabel(h) }}</span> }
            <span class="state-pill" [ngClass]="h.color">{{ getLabel(h.state) }}</span>
          </div>

          <dl class="detail-facts">
            <dt>Client</dt><dd>{{ h.customerName }}</dd>
            <dt>Facturation</dt>
            <dd>@if (h.billAddr !== null) { {{ h.billAddr }} } @else { <span class="missing-bill"><mat-icon>warning</mat-icon>non spécifiée</span> }</dd>
            @if (h.delivAddr) { <dt>Livraison</dt><dd>{{ h.delivAddr }}</dd> }
            <dt>Mode</dt><dd>{{ h.modeLabel }}{{ h.askdatdel ? ' · ' : '' }}{{ h.askdatdel | date:'dd/MM/yyyy' }}</dd>
            <dt>Commande</dt>
            <dd>créée le {{ h.created | date:'dd/MM/yyyy HH:mm' }}@if (h.validated) { · validée le {{ h.validated | date:'dd/MM/yyyy HH:mm' }} }</dd>
            <dt>Saisie</dt><dd>{{ userShortName(h.userId) || '—' }} · poste {{ h.stationId ?? '—' }}@if (storeOf(h)) { · Ets. {{ storeOf(h) }} }</dd>
          </dl>

          <table class="lines-table">
            <thead>
              <tr>
                <th class="col-name">Article livré</th>
                <th class="col-qty">Qté</th>
                <th class="col-price" title="Prix TTC du conditionnement, remise déduite">P.U. TTC</th>
                <th class="col-price">Total TTC</th>
              </tr>
            </thead>
            <tbody>
              @for (l of h.lines; track $index) {
                <tr>
                  <td class="col-name" [title]="l.product_name">{{ l.product_name }}</td>
                  <td class="col-qty">{{ l.qty }}</td>
                  <td class="col-price">{{ l.uprice_taxi | number:'1.2-2' }}</td>
                  <td class="col-price">{{ l.total_taxi | number:'1.2-2' }}</td>
                </tr>
              } @empty {
                <tr><td colspan="4" class="col-empty">Aucune ligne livrée sur ce BL.</td></tr>
              }
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3" title="Total que le serveur scellera : bases HT par taux, TVA arrondie une fois par taux">Total du BL ({{ h.total_taxx | number:'1.2-2' }}&nbsp;€ HT)</td>
                <td class="col-price">{{ h.total_taxi | number:'1.2-2' }}&nbsp;€</td>
              </tr>
            </tfoot>
          </table>
        </div>
      } @else {
        <div class="detail-card detail-empty">
          <mat-icon>ads_click</mat-icon>
          <span>Survolez un bon de livraison pour voir ses articles.</span>
        </div>
      }
    </div>
  </div>
</div>
